// extracted by mini-css-extract-plugin
export default {"inputData":"search_inputData__2dlzR","inputFilled":"search_inputFilled__C6sUo"};